import { Action } from 'redux'

export const createLatestRequestTracker = () => {
    let latest: Action | null = null

    return {
        markIssued(action: Action): void {
            latest = action
        },
        isLatest(resultAction: Action): boolean {
            const causedBy = (resultAction as { meta?: { causedBy?: Action } }).meta?.causedBy
            return !latest || !causedBy || causedBy === latest
        },
    }
}
